export default __webpack_public_path__ + "static/media/JavaScript_Unit_Testing_-_adamr.space___Codecademy.e3dc85c4.pdf";